import { useFormContext } from 'react-hook-form-mui';
import { useEffect } from 'react';
import { RhfMuiTextArea } from '../../molecules/fields/rhf-mui-fields';
import { useInternalDashboardSelector } from './Selector';

export const FormResolutionMessage = () => {
  const { setValue } = useFormContext();
  const { selectedRow } = useInternalDashboardSelector();
  useEffect(() => {
    setValue('message', selectedRow?.resolutionMessage || '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRow?.resolutionMessage]);

  return (
    <>
      <RhfMuiTextArea name='message' placeholder='Message' required parseError={(error) => error.message.toString()} />
    </>
  );
};
